module.exports = __webpack_public_path__ + "static/media/img_familiar.b2decff3.jpg";